"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query userRoles {
    userRoles {
      _id
      userId
      userEmail
      user {
        _id
        firstName
        lastName
        email
      }
      orgId
      org {
        userId
        orgName
        orgLogoUrl
        stripeId
      }
      role
      createdAt
      createdBy
      acceptedAt
    }
  }
`;
exports.default = query;
//# sourceMappingURL=userRoles.query.js.map